import { CheckCircleOutline, DoDisturbOn, Label } from "@mui/icons-material";
import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import {
    adderReset,
    GetAllAdders,
    UpdateAdderMethod,
    UpdateAdderStatus,
} from "../../Redux/AddersSlice/AddersSlice";

const AdderStatusConfirm = ({ data, status, close, rowsPerPage, page }) => {
    const { isSuccess } = useSelector((state) => state.adders);

    useEffect(() => {
        if (isSuccess) {
            console.log(isSuccess);
        }
    }, [isSuccess]);

    const dispatch = useDispatch();

    const CallNotificationMethod = async () => {
        if (isSuccess)
            toast.success("The condition has been successfully changed");
        await dispatch(
            GetAllAdders({
                paginate: rowsPerPage,
                page: page + 1,
            })
        );
        await dispatch(adderReset());
        status(false);
    };

    const handelChangeAdderStatus = async () => {
        await dispatch(UpdateAdderStatus(data.id));
        await CallNotificationMethod();
    };

    return (
        <>
            <FormHeading>
                You are about to change the situation of " {data.name} "
            </FormHeading>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Button
                            onClick={(e) => {
                                handelChangeAdderStatus();
                            }}
                            size="medium"
                            fullWidth
                            variant="contained"
                            color={
                                parseInt(data.status) === 0
                                    ? "primary"
                                    : "error"
                            }
                        >
                            {parseInt(data.status) === 0
                                ? "Active"
                                : "Inactive"}
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button
                            onClick={close}
                            size="medium"
                            fullWidth
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default AdderStatusConfirm;
